import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

/**
 * Create a wrapper composition to support DIalog functionality
 * @param ComposedComponent
 * @returns {{Component}}
 */

export function withDialogs(dialogs) {
    return function (ComposedComponent) {
        return @observer class extends Component {
            @observable showDialog = false;
            @observable dialogs = dialogs.reduce((res, dialog) => {
                res[dialog] = false;
                return res
            }, {});

            @action closeDialog = (name) => {
                this.dialogs[name] = false;
                if (!name) this.showDialog = false;
            };

            @action openDialog = (event, name) => {
                if (event) event.stopPropagation();
                this.dialogs[name] = true;
                if (!name) this.showDialog = true;
            };

            isOpen = (name) => {
                if (!(name in this.dialogs)) {
                    console.error(`Not Setted Dialog "${name}"! Call setDialog actions`);
                }
                return this.dialogs[name] || false;
            };

            render() {
                return <ComposedComponent {...this.props} showDialog={this.showDialog} openDialog={this.openDialog}
                                          closeDialog={this.closeDialog} isOpen={this.isOpen}/>;
            }
        };
    }
}
